import { Component, Input } from '@angular/core';

import { TabsComponent }    from '../tabs.component';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.less']
})

export class TabComponent {
  @Input() tabTitle: string;
  @Input() active: boolean;

  constructor(tabs: TabsComponent) {
    tabs.addTab(this);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/tabs/tab/tab.component.ts